import { render } from "./WayView.vue?vue&type=template&id=a2e93bce&ts=true"
import script from "./WayView.vue?vue&type=script&lang=ts"
export * from "./WayView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__